import React, { PureComponent } from 'react'
import { Button } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { fetchBusinessById, resetFetchBusinessById } from '../actions/business'
import { fetchBusinessIdentitiesById, resetFetchBusinessIdentitiesById } from '../actions/business_identities'
import { fetchBusinessSettings } from '../actions/business_settings'
import BusinessSettings from '../components/business_settings/business_settings'
import Addresses from '../components/common/addresses'
import DataListings from '../components/common/data_listings/data_listings'
import DataSources from '../components/common/data_sources'
import MediaReferences from '../components/common/media_references'
import RoundCornerIBox from '../components/common/round_corner_ibox'
import { ButtonBackDiv } from '../components/common/styled'
import TransactionNotesTable from '../components/common/transaction_notes'
import Spinner3Bounce from '../components/spinner_3_bounce'
import BusinessBeneficiaries from '../components/tx_business_components/business_beneficiaries'
import BusinessDocuments from '../components/tx_business_components/business_documents'
import BusinessIdStatus from '../components/tx_business_components/business_id_status'
import BusinessInfo from '../components/tx_business_components/business_info'
import BusinessTxDetailsButtons from '../components/tx_business_components/business_tx_business_buttons'
import { filterIdentityDataSources } from '../utils/filters'
import TxAuditLog from '../components/tx_details_components/tx_audit_log'
import { isBusinessUsingMinerva } from '../utils/helpers'
import AMLSources from '../components/common/aml_sources/aml_sources'
import AMLNonSanctionSources from '../components/common/aml_sources/aml_non_sanction_sources'

export class Business extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      width: window.innerWidth,
      sanctionListComplianceCount: 0,
      sanctionListMediaCount: 0,
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions)
  }

  componentDidMount() {
    const { id, fetchBusinessById, resetFetchBusinessById, fetchBusinessIdentitiesById, fetchBusinessSettings } =
      this.props
    this.updateDimensions()
    window.addEventListener('resize', this.updateDimensions)
    resetFetchBusinessById()
    fetchBusinessById(id)
    fetchBusinessIdentitiesById(id)
    fetchBusinessSettings(id)
  }

  updateDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  updateComplianceCount = (c) => {
    this.setState({ sanctionListComplianceCount: c })
  }

  updateMediaCount = (c) => {
    this.setState({ sanctionListMediaCount: c })
  }

  attemptApprove = (next) => {
    const {
      state: { sanctionListComplianceCount, sanctionListMediaCount },
    } = this
    console.log(sanctionListComplianceCount, sanctionListMediaCount)
    if (!sanctionListComplianceCount && !sanctionListMediaCount) {
      next()
    } else {
      window.alert(
        "Possible AML/Sanction Hits!  You must review each item in ‘Compliance: Possible Matches’ & ‘Media References' to verify your user is NOT on any AML (anti money laundering) lists. Review each hit & confirm it is not a match, then:" +
          "\n1. Click the checkbox under “Reviewed by Compliance” next to each hit (confirming not a match) & click ‘Approve'." +
          '\n2. Enter internal notes (to prove to government institutions that you did indeed check) & click ‘Save Changes’.'
      )
    }
  }

  render() {
    const { state, props } = this
    const {
      errorMessage,
      isAuthenticated,
      businessData,
      identities,
      isFetching,
      isIdentitiesFetching,
      viewTxDetails,
      settings,
    } = props
    if (!isAuthenticated) {
      return null
    }

    if (isFetching || isIdentitiesFetching) {
      return (
        <div className='text-center grid-spinner-mt-240'>
          <Spinner3Bounce isActive />
        </div>
      )
    }

    if (errorMessage) {
      return <div className='alert alert-success animated fadeIn'>{errorMessage}</div>
    }
    let klassCol9 = null
    let klassCol3 = null
    if (this.state.width > 810) {
      klassCol9 = 'col col-xs-9'
      klassCol3 = 'col col-xs-3'
    }
    return (
      <div className='animated fadeIn'>
        <ButtonBackDiv>
          <Button bsPrefix='btn btn-w-m btn-default shadow' onClick={() => window.history.back()}>
            <i className='fa fa-arrow-left' /> Back
          </Button>
        </ButtonBackDiv>
        <div>
          <div className={klassCol9}>
            <BusinessInfo data={businessData} />
          </div>
          <div className={klassCol3 + ' section-shadow round-corner-box'}>
            <div className='row'>
              <BusinessIdStatus state={businessData.status} />
            </div>
          </div>
        </div>
        <BusinessBeneficiaries viewTxDetails={viewTxDetails} data={identities.results} />
        <Addresses data={businessData.business_addresses} business={businessData} />
        <BusinessDocuments documents={businessData.business_documents} />
        <div className='text-center'>
          <BusinessTxDetailsButtons
            businessData={businessData}
            currentState={businessData.status}
            data={identities.results}
            id={businessData.id}
            attemptApprove={this.attemptApprove}
          />
        </div>
        {!isBusinessUsingMinerva(businessData) ? (
          <>
            {/*this section is for Comply Advantage results for clients with their own API keys and legacy Netki Results*/}
            <DataListings
              id={businessData.id}
              count={state.sanctionListComplianceCount}
              updateComplianceCount={this.updateComplianceCount}
              data={businessData.business_data_listings}
              hitsData={businessData.business_data_sources}
              identityDataSources={businessData.business_data_sources}
              mediaData={businessData.business_media_references}
              type={'business'}
            />
            <MediaReferences
              id={businessData.id}
              count={state.sanctionListMediaCount}
              updateMediaCount={this.updateMediaCount}
              hitsData={filterIdentityDataSources(businessData.business_data_sources)([
                parseInt(process.env.REACT_APP_COMPLY_ID),
                parseInt(process.env.REACT_APP_MINERVA_ID),
              ])}
              data={businessData.business_media_references}
            />
          </>
        ) : (
          <>
            {/*this section display Minerva results broken out by the sourceTypes (either Sanctions or PEP and News)*/}
            <AMLSources
              id={businessData.id}
              count={state.sanctionListComplianceCount}
              updateComplianceCount={this.updateComplianceCount}
              identityDataSources={businessData.business_data_sources}
              type={'business'}
              sourceTypes={['Sanctions']}
            />
            <AMLNonSanctionSources
              id={businessData.id}
              count={state.sanctionListComplianceCount}
              updateMediaCount={this.updateMediaCount}
              identityDataSources={businessData.business_data_sources}
              type={'business'}
              sourceTypes={['PEP', 'News']}
            />
          </>
        )}
        <DataSources data={businessData.business_data_sources} />
        <BusinessSettings data={settings} />
        <RoundCornerIBox title='Notes'>
          {businessData.business_notes && businessData.business_notes.length > 0 ? (
            <TransactionNotesTable data={businessData.business_notes} />
          ) : (
            <span>{'N/A'}</span>
          )}
        </RoundCornerIBox>
        <TxAuditLog data={businessData.business_metadata ? businessData.business_metadata.audit_logs : []} />
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  identities: state.businessIdentities.identities,
  settings: state.businessSettings.settings,
  isSettingsFetching: state.businessSettings.isFetching,
  isIdentitiesFetching: state.businessIdentities.isFetching,
  businessData: state.business.business,
  isAuthenticated: state.auth.isAuthenticated,
  errorMessage: state.business.errorMessage,
  isFetching: state.business.isFetching,
  id: ownProps.match.params.id,
  userTx: state.txById.userTx,
  isUserTxFetching: state.txById.isFetching,
})

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      fetchBusinessSettings,
      fetchBusinessIdentitiesById,
      resetFetchBusinessIdentitiesById,
      fetchBusinessById,
      resetFetchBusinessById,
      viewTxDetails: (id) => ownProps.history.push('/tx-details/' + id),
    },
    dispatch
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Business))
